import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M16.3 4h.2c1 0 2 .7 2.5 1.7v.2l.5 1.1h-2.2l-.2-.4a1 1 0 00-.8-.6H7.7a1 1 0 00-.7.5L4 13v4.5L5 16h4v2H6l-1.3 2H2v-7l1.2-3L2 9H1V7h1.2c.2 0 .4 0 .6.2l1.2 1 1-2.3v-.2A3 3 0 017.3 4h9zm-9.8 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3z" />
      <path fillRule="nonzero" d="M17 9l-5 5 5 5 1.5-1.5L16 15h8v-2h-8l2.5-2.5z" />
    </g>
  </svg>
);
